export default __webpack_public_path__ + "static/gain-mob-7251687b677204049166fe2ac27fc7ba.jpg";